import React from 'react'
import { connect } from 'react-redux';

import './style.css';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import { Table,
	Button,
	Modal,
	Spin,
	message,
	Row,
	Col,
	Icon,
	Divider,
	Form,
	Select,
} from 'antd';
import { fetchUserGroupDetailList,
	updateUserGroupDetailList,
	deleteUserGroupDetailList
 } from '../../actions/daily-report-actions';
 import { fetchEmployeesList,fetchEmployeesGroupList } from '../../actions/employee-management-actions.js';
import userGroupDetailService from '../../services/DailyReport/user-group-detail-service';
import debounce from 'lodash.debounce';

class UserGroupDetail extends React.Component {
	constructor (props) {
        super(props)
        // 使用 debounce 函数来节流 以 避免 onchange事件的频繁触发 导致页面的频繁重绘
        this.fetchUserList = debounce(this.fetchUserList, 800);
        this.state={
        	department_id:this.props.routing.location.pathname.split('/')[3]
        }
    }

	componentWillMount() {
		let department_id = this.props.routing.location.pathname.split('/')[3];
		this.props.fetchUserGroupDetailList(department_id)
		// let gets={
		// 	department_id:department_id
		// }
		// this.props.fetchEmployeesGroupList(gets)
		// console.log(this.props.fetchUserGroupDetailList(employee_id))
		// console.log(this.props.fetchUserGroupDetailList());
		
	}
	componentWillReceiveProps(nextProps) {
		// console.log(nextProps.dailyReports.userGroupList);
	}

	componentDidMount() {
		this._fetchEmployeesList()
		// console.log(this.props);
		let department_id = this.props.routing.location.pathname.split('/')[3];
		// this.props.fetchUserGroupDetailList(department_id)
		let gets={
			// department_id:parseInt(department_id)
			department_id:department_id
		}
		this.props.fetchEmployeesGroupList(gets)
	}
	

	_fetchEmployeesList = () => {
          this.props.fetchEmployeesList()
    }

	state = {
		currentModalStatus: false,
		groupUser:[]
	}
	closeCurrentModal = () => {
		this.setState({currentModalStatus: false});
	}
	rowSelection = {
		onChange: (selectedRowKeys, selectedRows) => {
			let employee_id = selectedRows.map(row => row.employee_id);
			this.setState({selectedIDs: employee_id});
		}
	}
	insertCurrent = () => {
		this.setState({currentModalStatus: true});
		// insert
		this.setState({currentData: {
			// employee_name: null,
			// reply_employees: null
		}});
		this.setState({
            groupUser: []
        })
		this.setState({currentIndex: null});
	}
	submitCurrentModal = () => {
		// submit
		this.props.form.validateFields((err, values) => {
			if (!err ) {
				// console.log(this.state);
				const { groupUser, charge_user_id } = this.state;
				// console.log(groupUser);
				
				let postId=this.props.routing.location.pathname.split('/')[3]

				if (null !== this.state.currentIndex) {
					// let groupUserID=[];
					// groupUser.forEach(data=>{
					// for (let i = 0; i < groupUser.length; i++) {
					// 	this.state.currentData.reply_employees.forEach(UserID => {
					// 		// console.log(groupUser[i]===UserID.employee_name)
					// 		if(groupUser[i]===UserID.employee_name){
					// 			groupUserID[i] = UserID.employee_id
					// 			// if(UserID.employee_id.indexOf(groupUserID)===-1){
					// 			// 	groupUserID.push(UserID.employee_id)
					// 			// }	
					// 		}else{
					// 			// if(groupUser[i].indexOf(groupUserID)===-1){
					// 			// 	groupUserID.push(groupUser[i])
					// 			// }
					// 			groupUserID[i] = groupUser[i]
					// 		}
					// 	})
					// 	// i++;
					// // })
					// }
					let groupUserID = [ ...groupUser ];

					if(groupUser.length<=0){
						let index=0;
						this.state.currentData.reply_employees.forEach(employee => {
							groupUserID[index] = employee.employee_id;
							index++;
							// console.log(groupUserID[index]);
						})
					}else{
						// console.log(this.state.currentData.reply_employees);
						this.state.currentData.reply_employees.forEach(employee => {
							let index = groupUser.indexOf(employee.employee_name);
							// console.log(index);
							if (-1 !== index) {
								groupUserID[index] = employee.employee_id;
							}
							// console.log(groupUserID[index])
						})
					}
					
					// console.log(groupUserID);
					let posts = {
						employee_id:this.state.currentData.employee_id,
		                department_id: this.props.routing.location.pathname.split('/')[3],
		                // reply_employee_ids: groupUserID.map(i => parseInt(i, 10)),
		                reply_employee_ids: groupUserID.map(i => i),
		                job_status:1,
						status:1
		            }
					// console.log(posts);
					this.props.updateUserGroupDetailList(posts, this.state.currentIndex, status => {
						this.props.fetchUserGroupDetailList(postId);
						if (status) {
							message.success("修改特殊查看人成功", 4);
						}else{
							message.error("修改特殊查看人失败", 4);
						}
					});
				}else{
					let posts = {
						employee_id:charge_user_id,
		                department_id: this.props.routing.location.pathname.split('/')[3],
		                // reply_employee_ids: groupUser.map(i => parseInt(i, 10)),
		                reply_employee_ids: groupUser.map(i => i),
		                job_status:1,
						status:1
		            }
					// let department_id = this.props.routing.location.pathname.split('/')[3];
					// posts.employee_id = this.state.currentData.employee_id;
					// posts.department_id = department_id;
					// posts.job_status=1;
					// posts.status=1;
					userGroupDetailService.addUserGroupDetailList(posts, res => {
						// console.log(postId)
						this.props.fetchUserGroupDetailList(postId);
						if (res.data.Success) {
							message.success("添加特殊查看人成功", 4);
						}else{
							message.error("添加特殊查看人失败"+res.data.Message, 4);
						}
					}, err => {});
				}
				this.closeCurrentModal();
			}
		})
	}
	updateCurrent = index => {
		this.setState({currentModalStatus: true});
		// update
		this.setState({currentData: this.props.dailyReports.userGroupData[index]});
		this.setState({currentIndex: index});
		this.setState({
            groupUser: []
        })
	}
	multiDelete () {
		if (!this.state.selectedIDs || this.state.selectedIDs.length === 0) {
			message.error('请选择特殊查看人', 4);
			return;
		}
		Modal.confirm({
			title: '确定删除?',
			okText: '确认',
			cancelText: '取消',
			onOk: () => {
				// console.log(this.state.selectedIDs);
				let postId=this.props.routing.location.pathname.split('/')[3]
				this.props.deleteUserGroupDetailList({ids: this.state.selectedIDs}, status => {
					if (status) {
						// this.props.fetchUserGroupDetailList(this.state.page);
						this.props.fetchUserGroupDetailList(postId);
					}
				});
			},
			onCancel: () => {}
		});
	}
	
    changeChargeUser = (v) => {
    	// if(v.length >= 3){
	    	let department_id = this.props.routing.location.pathname.split('/')[3];
	        let param = {
	          	real_name: v,
				// department_id:parseInt(department_id)
				department_id:department_id
	        }
	        this.props.fetchEmployeesGroupList(param);
   		// }
      }
    selectChargeUser = (name, obj) => {
        this.setState({
          charge_user_id: obj.props.data,
          charge_user_name: name
        });
    }

    fetchUserGroupList = (params) => {
        this.props.fetchEmployeesGroupList(params)
    }  
    handleSearchGroupChange = (v) => {
    	if(v.length >= 3){
    		let department_id = this.props.routing.location.pathname.split('/')[3];
	        let params = {
	        	real_name: v,
				// department_id:parseInt(department_id)
				department_id:department_id
	        };
	        this.fetchUserGroupList(params)
    	}	
    }
    handleSelectChange = (v) => {
    	// if(v.length >= 3){
			// console.log(v)
	        this.setState({
	            groupUser: v
	        })
	    // }
    }
    fetchUserList = (params) => {
        this.props.fetchEmployeesList(params)
    }
    handleSearchChange = (v) => {
    	if(v.length >= 3){
	        let params = {real_name: v};
	        this.fetchUserList(params)
   		}
    }
	fetchUserGroupDetailList = pagination => {
		// console.log(pagination);
		this.props.fetchUserGroupDetailList({page: pagination.current});
	}
	selectViewer =(value, obj) =>{
		this.setState({
          charge_user_ids: obj.props.data,
          charge_user_names: value
        });
	}
	// this.state.currentData.day_1
	render(){
		const dailyReportsUserGroupColumn = [
			{title: "员工姓名", 				key: "employee_id", dataIndex: "employee_name", className: 'table-global-head'},
			{title: "报告查看着", 		key: "reply_employees", dataIndex: "reply_employees", className: 'table-global-head',
			render: (text,record,index) => record.reply_employees.map((item,index) => {
			if(index===0){
				return (<span key={item.employee_id}>{item.employee_name}</span>)}
			else{
				return (<span key={item.employee_id}>, {item.employee_name}</span>)}
			}
			)},
			{title: "操作",					key: "action", dataIndex: "action", className: 'table-global-head',
			render: (text, record, index) => this.props.access.userGroup.u_value && 
				<Button icon="edit" size="small" className="row-action-btn"onClick={this.updateCurrent.bind(this, index)}>编辑</Button>
			}
		]
		// const { employeeList, fetching } = this.props.employeeManagement;
		// const { userGroupData } = this.props.dailyReports;
		// let employeeListData = userGroupData ? userGroupData.reply_employees : [],
		//  defaultGroupUserIds;
		// if (employeeListData) {
  //           console.log(userGroupData);
  //           defaultGroupUserIds = employeeListData.map(i => {
  //             console.log(i);
  //             return `${i.employee_id}`;
  //           })
  //           console.log(defaultGroupUserIds);
  //       }
		return(
			<div className="app-module-item">
				
				<Modal width="800px"
					visible={this.state.currentModalStatus}
					title="特殊查者设置"
					destroyOnClose={true}
					onCancel={this.closeCurrentModal}
					onOk={this.submitCurrentModal}>
					<div style={{textAlign: "center"}}>
						{this.state.currentData && 
						<Form onSubmit={this.submitCurrentModal} className="login-form" layout="inline">
							<div>
								<Row>
									<Col className="UserGroupDetailLable">
										报告者员工
									</Col>
									<Col className="UserGroupDetailContent">
										<Form.Item>
						                  {this.props.form.getFieldDecorator('employee_name', {
						                    rules: [{ required: true, message: '请输入报告者员工' }],
						                    initialValue: this.state.currentData.employee_name
						                  })( <Select mode="combobox"
						                      style={{ width: "500px" }}
						                      onChange={this.changeChargeUser}
						                      onSearch={this.handleSearchGroupChange}
						                      filterOption={false}
						                      placeholder="请输入报告者员工"
						                      onSelect={this.selectChargeUser} >
						                    {this.props.employeeManagement.employeeGroupList && this.props.employeeManagement.employeeGroupList.Data instanceof Array &&
						                      this.props.employeeManagement.employeeGroupList.Data.map(employee => {
						                      	// console.log(this.state.department_id)
						                      // if(employee.department_id===this.state.department_id){
						                      	return (
							                        <Select.Option key={employee.id} value={employee.real_name}
							                          data={employee.id} style={{width:"476px"}}>
							                          {employee.real_name}
							                        </Select.Option>)
						                      	// }
						                      
						                    })}
						                    </Select>)}
			               				 </Form.Item>
									</Col>
								</Row>
								<Row>
									<Col className="UserGroupDetailLable">
										查看者
									</Col>
									<Col className="UserGroupDetailContent">
										<Form.Item>
										{this.props.form.getFieldDecorator('reply_employees', {
						                    rules: [{ required: true, message: '请输入查看者' }],
						                    initialValue: this.state.currentData.reply_employees&&this.state.currentData.reply_employees.map(employee=>{
						                    	return (`${employee.employee_name}`)
						                    })
						                  })(
										<Select
										  mode="multiple"
										  filterOption={false}
										  style={{ width: 500 }}
										  notFoundContent={this.props.employeeManagement.fetching ? <Spin size="small" /> : null}
										  placeholder="请输入查看者"
										  onSearch={this.handleSearchChange}
										  onSelect={this.selectViewer}
										  onChange={this.handleSelectChange}>
										  {this.props.employeeManagement.employeeList && this.props.employeeManagement.employeeList.Data instanceof Array &&
						                      this.props.employeeManagement.employeeList.Data.map(employee => {
						                      return (
						                        <Select.Option key={employee.id} value={employee.id}
						                           style={{width:"476px"}}>
						                          {employee.real_name}
						                        </Select.Option>)
						                    })}
						                   {/*
						                   	 defaultValue={this.state.currentData.reply_employees?this.state.currentData.reply_employees.map(employee => employee.employee_name):[]}
						                   	{
			                                   this.state.currentData.reply_employees &&
			                                     this.state.currentData.reply_employees.map(i => <Select.Option key={i.employee_id}>{i.employee_name}</Select.Option>)
			                                     
			                               }
						                   {this.state.currentData&&this.state.currentData.reply_employees.map(item =>{
												return (
													<Select.Option key={item.employee_id} value={item.employee_name}
						                          data={item.employee_id} style={{width:"500px"}}>
						                          {item.employee_name}
						                        </Select.Option>)		
						                   })}*/}
										</Select>)}
										{/*)}*/}
										</Form.Item>
										{/*<Form.Item>
										 {this.props.form.getFieldDecorator('employee_name', {
						                    rules: [{ required: false, message: '查看者' }],
						                    initialValue: this.state.currentData.employee_name
						                  })(
										<Input.TextArea ref="reportReply" style={{ width: "500px" }} rows={5}
				                            onChange={this.setCurrentComment}></Input.TextArea>)}
                           				</Form.Item>*/}
                           			</Col>
                           		</Row>
                           		{/*<Row>
									<Col className="UserGroupDetailLable"></Col>
									<Col className="UserGroupDetailContent">
                           				<Form.Item>
						                  {this.props.form.getFieldDecorator('employee_name', {
						                    rules: [{ required: false, message: '查看者' }],
						                    initialValue: this.state.currentData.employee_name
						                  })( <Select mode="combobox"
						                  	  prefix={<Icon type="user"/>}
						                      style={{ width: "300px" }}
						                      onChange={this.changeChargeUser}
						                      filterOption={false}
						                      placeholder="请输入查看者"
						                      onSelect={this.selectChargeUser} >
						                    {this.props.employeeManagement.employeeList && this.props.employeeManagement.employeeList.Data instanceof Array &&
						                      this.props.employeeManagement.employeeList.Data.map(employee => {
						                      return (
						                        <Select.Option key={employee.id} value={employee.real_name}
						                          data={employee.id} style={{width:"300px"}}>
						                          {employee.real_name}
						                        </Select.Option>)
						                    })}
						                    </Select>)}
			               				 </Form.Item>
									</Col>
								</Row>*/}
								
							</div>
						</Form>}
					</div>
				</Modal>
				<div className="colAction">
					{this.props.access.userGroup.c_value && <Button type="primary"  onClick={this.insertCurrent}>
						<Icon type="plus-circle-o"/>
						<span>新增</span>
					</Button>}
					<Divider type="vertical" />
					{this.props.access.userGroup.d_value && <Button type="primary" onClick={this.multiDelete.bind(this)}>
						<Icon type="delete" />
						<span>批量删除</span>
					</Button>}
				</div>
				
				<Table columns={dailyReportsUserGroupColumn} dataSource={this.props.dailyReports.userGroupData}
				pagination={{total: this.props.dailyReports.userGroupTotalPage,
						defaultCurrent: 1,
						pageSize: this.props.dailyReports.userGroupPageSize,
						current: this.props.dailyReports.userGroupPage}}
					onChange={this.fetchUserGroupDetailList.bind(this)}
					rowKey={record => record.employee_id} rowSelection={this.rowSelection}
				/>
			</div>
		)
	}
}
const mapStateToProps = state => {
	return {
		routing: state.routing,
		dailyReports: state.dailyReports,
		employeeManagement: state.employeeManagement,
	}
}
const mapDispatchToProps = {
	fetchUserGroupDetailList,
	updateUserGroupDetailList,
	deleteUserGroupDetailList,
	fetchEmployeesGroupList,
	fetchEmployeesList
}
//必须调用Form.create()，否则在使用getFieldDecorator时便会出现getFieldDecorator of undefined错误
UserGroupDetail = Form.create()(UserGroupDetail);

export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(UserGroupDetail));
// export default LayoutWrapper(connect(AttendanceTemplate));


// WEBPACK FOOTER //
// ./src/routes/DailyReport/UserGroupDetail.js